import { render, staticRenderFns } from "./processSetView.vue?vue&type=template&id=32461b1f&"
import script from "./processSetView.vue?vue&type=script&lang=js&"
export * from "./processSetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports